export default {
  callLog: {
    callLog: "Call log",
    consumeLog: "Consumption Log",
    apiNameRequired: "Please enter the interface name",
    proxyOrgNameRequired: "Please enter the calling company",
    callResultRequired: "Please select the call result",
    success: "success",
    failure: "failure",
    startTime: "Start date",
    endTime: "End date",
    logList: "Log list",
    // apiCode: "Interface code",
    apiName: "Interface Name",
    responseCode: "Response code",
    responseTime: "Response time",
    proxyOrgName: "Caller enterprise",
    requestTime: "Request time",
    callResult: "Call result",
    baseInfo: "Basic information",
    requestHeader: "Request Header",
    reqBody: "Request body",
    respBody: "Response body",
    // apiCode: "Interface code",
    cancel: "Cancel",
    apiName: "Interface Name",
    proxyOrgName: "Caller",
    orgName: "Service Provider",
    requestTime: "Request time",
    requestMethod: "Request Method",
    responseCode: "Response code",
    responseTime: "Response time",
    searchCondition: "Search condition",
    proxyOrgNameRequired: "Please select the calling company",
    timeRangeRequired: "Select time and date",
    verificationResult: "Verification result",
    proofTheory: "proofTheory:",
    linkAddress: "Link address:",
    linkTime: "Link time:",
    blockHeight: "Block height:",
    goToAppeal: "Go to appeal",
    appealInfo: "Appeal info",
    appealDetail: "Appeal detail",
    appealEnterprise: "Appeal enterprise:",
    applicant: "applicant:",
    reasonForApplication: "Reason For Application:",
    attachments: "attachments:",
    approvalOpinion: "Approval Opinion:",
    file: "file:",
    uploadFile: "uploadFile",
    save: "save",
    verificationAppeal: "Verification appeal",
    cancle: "cancle",
    appealReview: "Appeal review",
    verifyStatus: "Verify status",
    verifyUser: "Verify user",
    verifyDate: "Verify date",
    fileDownload: "File Download",
    show: "The Body of the current response is a file. Download it and view it",
    name: "name",
    type: "type",
    value: "value",
    verified: 'Verified',
    inVerification: "Verification",
    normal: 'normal',
    abnormal: "abnormal"
  },
  callStatistics: {
    tenMinutes: "ten mins",
    hour: "hour",
    day: "day",
    week: "week",
    month: "month",
    year: "year",
    runNumber: "Number of running services",
    callNumber: "Number of service calls",
    flowStatistics: "Service traffic statistics (kb)",
    averageRes: "Average response time (ms)",
    startPlaceholder: "Start date and time",
    endPlaceholder: "End date and time",
    successTimes: "Number of successes",
    errorTimes: "Number of failures",
    totalCalls: "Total number of calls",
    totalFlow: "Total flow",
    network: "Request failed,",
    refresh: "click refresh",
    empty: "No Data",
    successCount: "success count",
    failCount: "fail count"
  },
  cloudInterface: {
    cloudApiList: "Cloud interface list",
    authorizeApiList: "Authorization interface list",
    searchCondition: "Search condition",
    orgRequired: "Please select a company",
    // searchApiCode: "Query interface code",
    searchApiName: "Query interface name",
    searchCodeAndName: "Query interface code/interface name",
    // apiCode: "Interface code",
    apiName: "Interface Name",
    // categoryName: "Application Service",
    apiClassify: "Interface Classification",
    remark: "description",
    orgName: "Owned enterprise",
    status: "Status",
    apply: "Apply",
    detail: "detail",
    debug: "debug",
    delete: "delete",
    apiApply: "Interface call application",
    reasonRequired: "Please enter the reason for application",
    baseInfo: "Basic information",
    requestHeader: "Request Header",
    reqBody: "Request body",
    respBody: "Response body",
    visibleRange: "Visible range",
    classify: "category",
    category: "Interface Application",
    isExamine: "Whether third-party calls require approval",
    yes: "Yes",
    no: "No",
    apiProtocol: "Interface Protocol",
    remark: "Interface Description",
    apiUrl: "Interface Address",
    requestMethod: "Request Method",
    aggree: "Agree",
    reject: "Reject",
    hiddenUrlTip:
      "Please go to the authorized interface list to view it after applying",
    apiIntroduction: "API Introduction",
    apiDefinition: "API Request & Response Definition",
    apiPath: "Api Path",
    need: "need",
    unNeed: "unNeed",
    public: "Public interface",
    interfaceCenter: 'Interface Center',
    TCPCenter: "TCP Center",
    MQTTCenter: "MQTT Center",

    TCPName: 'TCP Name',
    describe: 'Describe',
    url: 'Original Port',
    forwardPort: 'Proxy Port',
    TCPCenterSearchPlaceholder: 'Query TCP name',
    MQTTPlaceholder: "query MQTT name",

    mqttName: "MQTT Name",
    broker: "Broker Address",
    topic: "Topic",
    orgName: "Apply Organization",
    describe: "Describe"
  }
};



// WEBPACK FOOTER //
// ./src/views/cloudInterface/cloudInterface.en.js